import React from 'react';

const DefaultMapFooter = () => (
  <div>
    <div className="graph-key" >
      <div className="tier1">
        Tier 1: Ranked 1-13
      </div>
      <div className="tier2">
        Tier 2: Ranked 14-26
      </div>
      <div className="tier3">
        Tier 3: Ranked 27-40
      </div>
    </div>
    <div className="graph-sources">
      Sources<sup>
        <a href="https://www.politifact.com/largestcities/">3
        </a>
      </sup>
      &nbsp;
      <sup>
        <a href="https://www.census.gov/quickfacts/fact/table/US/PST045216">4</a>
      </sup>
    </div>
  </div>
);

export default DefaultMapFooter;



// WEBPACK FOOTER //
// ./src-react/UsaMap/footers/DefaultMapFooter.jsx